import axios from "axios";

export const getPublicURL = (url) => {
  const output = //"https://colagio.shratech.com";
    process.env.NODE_ENV !== "production"
      ? "http://localhost:5000"
      : "https://colagio.shratech.com";
  return output;
};

export const getAPIUrl = async () => {
  const res = await axios.post(
    `${getPublicURL()}/api_colagio/info/institution`,
    {
      domain: window.location.hostname,
    }
  );
  return res.data.data;
};
